import React, { useState, useEffect } from "react";
import { Card, Form, Button, Breadcrumb } from "react-bootstrap";
import { Icon } from "@iconify/react";
import UploadImageComponent from "../../components/UploadImageComponent";
import InputLeftIcon from "../../components/form_item/InputLeftIcon";
import { SuccessSwal, WarningSwal } from "../../helpers/alertseet";
import { useNavigate } from "react-router-dom";
import { END_IMAGE } from "../../constants";
import { add_member } from "../../services/membership.service";
import { useStore } from "../../store/useStore";
import {
  getProvices,
  getDistrictsByProvinceName,
} from "../../services/masterdata.service";
import { Formik } from "formik";
import * as Yup from "yup";
import InputField from "../../components/form_item/InputField";

export default function CreateMembershipPage() {
  const navigate = useNavigate();
  // state
  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({});

  // store
  const { token, branchData } = useStore();

  // Validation Schema using Yup
  const validationSchema = Yup.object().shape({
    memberNo: Yup.string()
      .required("ກະລຸນາປ້ອນເລກສະມາຊິກ")
      .matches(/^\d{4}$/, "ເລກສະມາຊິກຕ້ອງມີ 4 ໂຕເລກ"),
    firstName: Yup.string().required("ກະລຸນາປ້ອນຊື່"),
    lastName: Yup.string().required("ກະລຸນາປ້ອນນາມສະກຸນ"),
    gender: Yup.string().required("ກະລຸນາເລືອກເພດ"),
    phone: Yup.string()
      .required("ກະລຸນາປ້ອນເບີໂທ")
      .matches(/^\d{10}$/, "ເບີໂທຕ້ອງມີ 10 ໂຕເລກ"),
    birthday: Yup.date().required("ກະລຸນາເລືອກວັນເດືອນປີເກີດ"),
    occupation: Yup.string().required("ກະລຸນາປ້ອນອາຊີບ"),
    homeUnit: Yup.string().required("ກະລຸນາປ້ອນໜ່ວຍ"),
    homeNumber: Yup.string().required("ກະລຸນາປ້ອນເຮືອນເລກທີ"),
    province: Yup.string().required("ກະລຸນາເລືອກແຂວງ"),
    district: Yup.string().required("ກະລຸນາເລືອກເມືອງ"),
    village: Yup.string().required("ກະລຸນາປ້ອນບ້ານ"),
    incomeActivity: Yup.string().required("ກະລຸນາປ້ອນແຫຼ່ງສ້າງລາຍຮັບ"),  });
  // Initial Values
  const initialValues = {
    branchId: branchData?._id,
    memberNo: "",
    firstName: "",
    lastName: "",
    gender: "",
    phone: "",
    birthday: "",
    occupation: "",
    homeUnit: "",
    homeNumber: "",
    province: "",
    district: "",
    village: "",
    familyNumber: "",
    personalID: "",
    incomeActivity: "",
    documentType: "ID_CARD"

  };
  // useEffect
  useEffect(() => {
    getProvices().then((res) => {
      setProvinceList(res?.data);
    });
  }, []);

  useEffect(() => {
    if (formData?.province) {
      console.log(formData?.province);
      getDistrictsByProvinceName(formData?.province).then((res) => {
        setDistrictList(res?.data);
      });
    }
  }, [formData?.province]);

  const handleCreateMember = async (values) => {
    try {
      if (isLoading) {
        WarningSwal("ກະລຸນາລໍຖ້າ");
        return;
      }
      const newData ={
...values,
profileImage:formData?.profileImage || ""
      }
      setIsLoading(true);
      const data = await add_member(newData, token);
      if (data?.error) {
        throw new Error(data?.message);
      }

      setIsLoading(false);
      SuccessSwal("ສ້າງບັນຊີສຳເລັດ!");
      navigate("/membership", { replace: true });
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={() => navigate("/membership", { replace: true })}
        >
          ບັນຊີສະມາຊິກ
        </Breadcrumb.Item>
        <Breadcrumb.Item active>ເພີ່ມບັນຊີ</Breadcrumb.Item>
      </Breadcrumb>
      <Card
        style={{
          padding: "20px 20px",
          minHeight: "80dvh",
          position: "relative",
          paddingBottom: 150,
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "auto 1fr",
            gap: 20,
            gridGap: 20,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <h2>ຮູບພາບ</h2>
            <div>
              <UploadImageComponent
                src={
                  formData?.profileImage
                    ? END_IMAGE + formData?.profileImage
                    : ""
                }
                style={{ width: 160, height: 160, objectFit: "cover" }}
                onChange={(image) =>
                  setFormData((prev) => ({
                    ...prev,
                    profileImage: image,
                  }))
                }
              />
            </div>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            validate={(values) => {
             const  errors = {};
              if(values.documentType === "ID_CARD"){
                if (!values.personalID) {
                  errors.personalID = "ກະລຸນາປ້ອນເລກບັດປະຈໍາຕົວ";
                }
              }
              if(values.documentType === "FAMILY_CARD"){
                 if(!values.familyNumber){
                  errors.familyNumber = "ກະລຸນາປ້ອນເລກສໍາມະໂນຄົວ";
              }
            }
              return errors;
            }}
            onSubmit={(values) => {
              console.log("values", values);
              //
              handleCreateMember(values);
            }}
          >
            {(
             {
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              handleSubmit
             }
            ) => (
              <form onSubmit={handleSubmit}>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 20 }}
                >
                  <h2>ຂໍ້ມູນສ່ວນໂຕ</h2>
                  <Form.Group>
                    <Form.Label>ເລກສະມາຊິກ</Form.Label>
                    <InputField
                      icon={
                        <Icon
                          icon="tabler:id"
                          style={{ width: 24, height: 24 }}
                        />
                      }
                      placeholder="ກະລຸນາປ້ອນຂໍ້ມູນ..."
                      name="memberNo"
                      maxLength={4}
                      value={values?.memberNo}
                      errors={errors?.memberNo}
                      touched={touched?.memberNo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>ຊື່</Form.Label>
                    <InputField
                      icon={
                        <Icon
                          icon="material-symbols:person-outline"
                          style={{ width: 24, height: 24 }}
                        />
                      }
                      placeholder="ກະລຸນາປ້ອນຊື່"
                      name="firstName"
                      value={values.firstName}
                      touched={touched.firstName}
                      errors={errors.firstName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>ນາມສະກຸນ</Form.Label>
                    <InputField
                      icon={
                        <Icon
                          icon="material-symbols:person-outline"
                          style={{ width: 24, height: 24 }}
                        />
                      }
                      placeholder="ກະລຸນາປ້ອນນາມສະກຸນ"
                      name="lastName"
                      value={values.lastName}
                      touched={touched.lastName}
                      errors={errors.lastName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>ເພດ</Form.Label>
                    <div style={{ display: "flex", gap: 20 }}>
                      <Form.Check
                        type="radio"
                        label={`ຊາຍ`}
                        name="gender"
                        id="radio-sex-m"
                        isInvalid={touched?.gender && errors?.gender}
                        value="MALE"
                        checked={values?.gender === "MALE"}
                        onChange={handleChange}
                      />
                      <Form.Check
                        type="radio"
                        label={`ຍິງ`}
                        name="gender"
                        id="radio-sex-f"
                        isInvalid={touched?.gender && errors?.gender}
                        value="FEMALE"
                        checked={values?.gender === "FEMALE"}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.gender && touched.gender && (
                      <p style={{ color: "#FF0000" }}>{errors.gender}</p>
                    )}
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>ເບີໂທ</Form.Label>
                    <InputField
                      icon={
                        <Icon
                          icon="uil:phone-alt"
                          style={{ width: 24, height: 24 }}
                        />
                      }
                      placeholder="20XXXXXXXX"
                      name="phone"
                      type={"tel"}
                      value={values.phone}
                      touched={touched.phone}
                      errors={errors.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>ວັນ/ເດືອນ/ປີ ເກີດ</Form.Label>
                    <InputField
                      icon={
                        <Icon
                          icon="uil:user-plus"
                          style={{ width: 24, height: 24 }}
                        />
                      }
                      type="date"
                      name="birthday"
                      value={values.birthday}
                      touched={touched.birthday}
                      errors={errors.birthday}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>ອາຊີບ</Form.Label>
                    <InputField
                      icon={
                        <Icon
                          icon="uil:suitcase-alt"
                          style={{ width: 24, height: 24 }}
                        />
                      }
                      placeholder="ປ້ອນອາຊີບ"
                      name="occupation"
                      value={values.occupation}
                      touched={touched.occupation}
                      errors={errors.occupation}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>ໜ່ວຍ</Form.Label>
                    <InputField
                      icon={
                        <Icon
                          icon="material-symbols:cottage-outline-rounded"
                          style={{ width: 24, height: 24 }}
                        />
                      }
                      placeholder="ປ້ອນໜ່ວຍ"
                      name="homeUnit"
                      value={values.homeUnit}
                      touched={touched.homeUnit}
                      errors={errors.homeUnit}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>ເຮືອນເລກທີ</Form.Label>
                    <InputField
                      icon={
                        <Icon
                          icon="material-symbols:cottage-outline-rounded"
                          style={{ width: 24, height: 24 }}
                        />
                      }
                      placeholder="ປ້ອນເຮືອນເລກທີ"
                      name="homeNumber"
                      value={values.homeNumber}
                      touched={touched.homeNumber}
                      errors={errors.homeNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>ແຂວງ</Form.Label>
                    <Form.Select
                      name="province"
                      isInvalid={touched?.province && errors?.province}
                      value={values.province}
                      onChange={(e) => {
                        handleChange(e);
                        setFormData((prev) => ({
                          ...prev,
                          province: e.target.value,
                        }));
                      }}
                    >
                      <option>ເລືອກເເຂວງ</option>
                      {provinceList?.map((item) => (
                        <option value={item.provinceName} key={item._id}>
                          {item.provinceName}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.province && touched.province && (
                      <p style={{ color: "#FF0000" }}>{errors.province}</p>
                    )}
                  </Form.Group>

                  {/* District */}
                  <Form.Group>
                    <Form.Label>ເມືອງ</Form.Label>
                    <Form.Select
                      name="district"
                      value={values.district}
                      onChange={handleChange}
                      isInvalid={touched?.district && errors?.district}
                    >
                      <option>ເລືອກເເມືອງ</option>
                      {districtList?.map((item) => (
                        <option value={item.districtName} key={item._id}>
                          {item.districtName}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.district && touched.district && (
                      <p style={{ color: "#FF0000" }}>{errors.district}</p>
                    )}
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>ບ້ານ</Form.Label>
                    <InputField
                      icon={
                        <Icon
                          icon="uil:location-point"
                          style={{ width: 24, height: 24 }}
                        />
                      }
                      placeholder="ກະລຸນາປ້ອນຂໍ້ມູນ..."
                      name="village"
                      value={values.village}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.village}
                      errors={errors.village}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>ເອກະສານຢັ້ງຢືນ</Form.Label>
                    <div style={{ display: "flex", gap: 20 }}>
                      <Form.Check
                        type="radio"
                        label={`ບັດປະຈໍາຕົວ`}
                        name="documentType"
                        isInvalid={touched?.documentType && errors?.documentType}
                        value="ID_CARD"
                        checked={values?.documentType === "ID_CARD"}
                        onChange={handleChange}
                      />
                      <Form.Check
                        type="radio"
                        label={`ສໍາມະໂນຄົວ`}
                        name="documentType"
                        isInvalid={touched?.documentType && errors?.documentType}
                        value="FAMILY_CARD"
                        checked={values?.documentType === "FAMILY_CARD"}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.documentType && touched.documentType && (
                      <p style={{ color: "#FF0000" }}>{errors.documentType}</p>
                    )}
                  </Form.Group>
                
                   {
                     values?.documentType === "ID_CARD" ? (
                      <Form.Group>
                        <Form.Label>ເລກບັດປະຈໍາຕົວ</Form.Label>
                        <InputField
                          icon={
                            <Icon
                              icon="uil:money-bill"
                              style={{ width: 24, height: 24 }}
                            />
                          }
                          placeholder="ເລກບັດປະຈໍາຕົວ"
                          name="personalID"
                          value={values.personalID}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.personalID}
                          errors={errors.personalID}
                        />
                      </Form.Group>
                     ):(
                      <Form.Group>
                        <Form.Label>ເລກສໍາມະໂນຄົວ</Form.Label>
                        <InputField
                          icon={
                            <Icon
                              icon="uil:money-bill"
                              style={{ width: 24, height: 24 }}
                            />
                          }
                          placeholder="ເລກສໍາມະໂນຄົວ"
                          name="familyNumber"
                          value={values.familyNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.familyNumber}
                          errors={errors.familyNumber}
                        />
                      </Form.Group>
                     )
                   }
                  <div>
                    <Form.Label>ກິດຈະກຳສ້າງລາຍຮັບ</Form.Label>
                    <InputField
                      icon={
                        <Icon
                          icon="uil:money-bill"
                          style={{ width: 24, height: 24 }}
                        />
                      }
                      placeholder="ປ້ອນແຫຼ່ງສ້າງລາຍຮັບ"
                      name="incomeActivity"
                      type={"text"}
                      value={values?.incomeActivity}
                      touched={touched.incomeActivity}
                      errors={errors.incomeActivity}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: 20,
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      variant="outline-primary"
                      size="md"
                      onClick={() => {
                        navigate("/membership", { replace: true });
                      }}
                    >
                      ຍົກເລີກ
                    </Button>
                    <Button disabled={isLoading} type={"submit"} size="md">
                        {isLoading ? "ກໍາລັງບັນທຶກ..." : "ສ້າງບັນຊີ "}
                    </Button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </Card>
    </div>
  );
}
